import React from "react";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import { ExpansionPanel } from "../../../common";
import { ActionPropsProps } from "../ActionProps";
import { ActionType } from "../../buttonModels";

const ZaloSettings: React.FC<ActionPropsProps> = ({ formal, pathPrefix }) => {
  return (
    <ExpansionPanel title="Zalo Settings">
      <FormGroup>
        <TextField
          label="Type"
          select
          SelectProps={{
            native: true,
          }}
          {...formal.getTextFieldProps(
            `${pathPrefix}properties.zalo-link-type`,
          )}
        >
          {Object.entries(ActionType.ZALO_LINK_TYPE).map(([value, name]) => (
            <option key={value} value={value}>
              {name}
            </option>
          ))}
        </TextField>
      </FormGroup>
    </ExpansionPanel>
  );
};

export default ZaloSettings;
